import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { PinnedResourceListComponent } from './pinned-resource-list/pinned-resource-list.component';

@NgModule({
  declarations: [
    PinnedResourceListComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    PinnedResourceListComponent
  ]
})
export class PinnedResourceModule { }
